import React, { useState } from "react";
import { IC } from "../../resources/Assets";

export default ( {children} ) => {
    const [ openHist, setOpenHist ] = useState(false);

    const commonArrowStyle = {
        width:"14px"
    }

    return(
        <div style={{paddingTop:"10px"}}>
            {openHist && children}

            <div style={{margin:"auto"}}>
                <div style={{display:"flex"}}>
                    <p style={{marginLeft:"auto", marginRight:"10px"}}>
                        이달의 경과 검사
                    </p>
                    <div style={{
                        border:"1px solid #dcdcdc"
                        , borderRadius:"16px"
                        , textAlign:"center"
                        , width:"30%"
                        , marginRight:"auto"
                    }}
                        onClick={openHist ? ()=>setOpenHist(false) : ()=>setOpenHist(true)}
                    >
                            
                        {
                            openHist
                                ?   <img src={IC.etc.IC_ARROW_UP_SILVER} style={commonArrowStyle} />
                                :   <img src={IC.etc.IC_ARROW_DOWN_SILVER} style={commonArrowStyle} />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}